import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout.js";
import "../../assets/styles/pages/Relatorio/PowerBI.scss";
import InputForm from "../../components/Form/InputForm.js";
import Chart from "react-apexcharts";
import business from "../../services/business.js";
import tools from "../../lib/tools.js";
import config from "../../config/config.js";

export default function PowerBI() {

    const typeProcess = [
        {
            id: 0,
            nome: "Todos"
        },
        {
            id: 1,
            nome: "Segunda opinião"
        },
        {
            id: 2,
            nome: "Consenso pré"
        },
        {
            id: 3,
            nome: "Junta médica ou odontológica"
        }
    ];

    /*    const [options] = useState({
           estados: business.getEstadosUF()
       }); */

    const [filtros, setFiltros] = useState({
        uf: '',
        id_tipo_processo: '',
        id_operadora: '',
        id_especialidade: '',
        id_area_atuacao: '',
        inicio_processo_inicio: '',
        inicio_processo_fim: '',
        data_conclusao_inicio: '',
        data_conclusao_fim: ''
    });

    const [filtro, setFiltro] = useState(false);

    const setModel = async (name, value) => {
        await setFiltros(prev => ({ ...prev, [name]: value }));
    };

    const [chartOptions, setChartOptions] = useState({
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: []
        }
    });

    const [chartSeries, setChartSeries] = useState([{
        name: "Total processos",
        data: []
    }]);

    const [areaAtuacaoOptions, setAreaAtuacaOptions] = useState({
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: []
        }
    });

    const [areaAtuacaoSeries, setAreaAtuacaoSeries] = useState([{
        name: "Total processos",
        data: []
    }]);

    const [tiposFinalizacao, setTiposFinalizacao] = useState({
        chart: {
            type: 'bar',
            height: 350
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end',
                horizontal: true
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: [],
        }
    });

    const [tiposFinalizacaoSeries, setTiposFinalizacaoSeries] = useState([
        {
            data: []
        }
    ]);

    const [listagemSaude, setListagemSaude] = useState([]);

    const [listagemAtuacao, setListagemAtuacao] = useState([]);

    const [listagem, setListagem] = useState([]);

    const [dadosStatus, setDadosStatus] = useState([]);

    const [dadosFinanceiros, setDadosFinanceiros] = useState([]);

    /*   const [donutOptions, setDonutOptions] = useState({
          labels: []
      }); */

    const [tempoMedioFinalizacao, setTempoMedioFinalizacao] = useState([]);

    const [donutSeries, setDonutSeries] = useState([]);

    const donutColors = ["#008ffb", "#00e396", "#feb019"]

    const [radialSeries, setRadialSeries] = useState([0]);

    const [radialOptions] = useState({
        chart: {
            type: 'radialBar',
            offsetY: -20,
            sparkline: {
                enabled: true
            }
        },
        plotOptions: {
            radialBar: {
                startAngle: -90,
                endAngle: 90,
                track: {
                    background: "#e7e7e7",
                    strokeWidth: '97%',
                    margin: 5,
                    dropShadow: {
                        enabled: true,
                        top: 2,
                        left: 0,
                        color: '#444',
                        opacity: 1,
                        blur: 2
                    }
                },
                dataLabels: {
                    name: {
                        show: false
                    },
                    value: {
                        offsetY: -2,
                        fontSize: '22px',
                        formatter: (val) => `${((val / 100) * 7).toFixed(2)} dias`
                    }
                }
            }
        },
        grid: {
            padding: {
                top: -10
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                shadeIntensity: 0.4,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 50, 53, 91]
            }
        },
        labels: ['Tempo médio']
    });

    const arredondarPorcentagem = (valor) => {
        const multiplicador = Math.pow(10, 1);
        return Math.round(valor * multiplicador) / multiplicador;
    }

    const getSearch = async (loading = true) => {
        setLoading(loading);
        const bi = await business.getRelatorioPowerBi({
            uf: filtros.uf,
            id_tipo_processo: filtros.id_tipo_processo,
            id_operadora: filtros.id_operadora,
            id_especialidade: filtros.id_especialidade,
            id_area_atuacao: filtros.id_area_atuacao,
            inicio_processo_inicio: filtros.inicio_processo_inicio,
            inicio_processo_fim: filtros.inicio_processo_fim,
            data_conclusao_inicio: filtros.data_conclusao_inicio,
            data_conclusao_fim: filtros.data_conclusao_fim,
        });

        const processosPorEspecialidade = bi?.response?.processosPorEspecialidade || [];
        const processosPorAreaAtuacao = bi?.response?.processosPorAreaAtuacao || [];
        const tipoFinalizacao = bi?.response?.tiposfinalizacaoPorEtapa || [];
        const saudeEconomicaEspecialidade = bi?.response?.saudeEconomicaEspecialidade || [];
        const saudeEconomicaAreaAtuacao = bi?.response?.saudeEconomicaAreaAtuacao || [];
        const rankingSaudeEconomica = bi?.response?.rankingSaudeEconomica || [];
        const contagem = bi?.response?.contagens || {};
        const economia = bi?.response?.economia || {};
        const distribuicaoServico = bi?.response?.distribuicaoServico || [];
        setTempoMedioFinalizacao(bi?.response?.tempoMedioFinalizacao || []);

        setChartOptions({
            chart: { id: "basic-bar" },
            xaxis: {
                categories: processosPorEspecialidade.map(p => p.nome_especialidade || "")
            }
        });

        setChartSeries([{
            name: "Total processos",
            data: processosPorEspecialidade.map(p => Number(p.total_processos_finalizados))
        }]);

        setAreaAtuacaOptions({
            chart: { id: "basic-bar" },
            xaxis: {
                categories: processosPorAreaAtuacao.map(p => p.nome_area_atuacao || "")
            }
        });

        setAreaAtuacaoSeries([{
            name: "Total processos",
            data: processosPorAreaAtuacao.map(p => Number(p.total_processos_finalizados))
        }]);

        // Chart 2 - Finalização por tipo de status (horizontal bar)
        setTiposFinalizacao(prev => ({
            ...prev,
            xaxis: {
                categories: tipoFinalizacao.map(p => p.status)
            }
        }));

        setTiposFinalizacaoSeries([{
            name: "Quantidade",
            data: tipoFinalizacao.map(p => Number(p.quantidade))
        }]);

        setListagemSaude(saudeEconomicaEspecialidade);
        setListagem(rankingSaudeEconomica);
        setListagemAtuacao(saudeEconomicaAreaAtuacao);
        setDadosStatus([
            {
                titulo: "Finalizados",
                valor: contagem.finalizados
            },
            {
                titulo: "Cancelados",
                valor: contagem.cancelados
            },
            {
                titulo: "Andamento",
                valor: contagem.andamento
            },
            {
                titulo: "Expirados",
                valor: contagem.expirados
            }
        ]);

        setDadosFinanceiros([
            {
                titulo: "Valor inicial",
                valor: tools.formatCurrency(economia.total_inicial),
                color: false
            },
            {
                titulo: "Valor final",
                valor: tools.formatCurrency(economia.total_final),
                color: false
            },
            {
                titulo: "Saúde econômica",
                valor: tools.formatCurrency(economia.total_economizado),
                color: false
            },
            {
                titulo: "o valor investido (ROI)",
                valor: (economia.ROI ? parseInt(economia.ROI) : 0) + 'x',
                color: true
            }
        ]);

        const totalProcessos = distribuicaoServico.reduce(
            (acumulator, p) => acumulator + Number(p.quantidade),
            0
        );

        /*   setDonutOptions(prev => ({
              ...prev,
              labels: distribuicaoServico.map(p => p.tipo_processo)
          })); */

        setDonutSeries(distribuicaoServico.map(p => {
            return {
                porcentagem: arredondarPorcentagem((Number(p.quantidade) / totalProcessos) * 100),
                numeroProcessos: p.quantidade,
                label: p.tipo_processo
            };
        }));

        setLoading(false);
        setSearchLoading(false);
    };

    // eslint-disable-next-line 
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const limparFiltros = () => {
        setFiltros({});
        setFiltros(false);
        window.location.reload();
    }

    useEffect(() => {
        const calcularTempoMedioFinalizacao = async () => {
            const resultados = await Promise.all(
                tempoMedioFinalizacao.map(async (processo) => {
                    const diasUteis = await tools.diasUteisEntreDatas(
                        processo.inicio_processo,
                        (processo.data_reabertura ? processo.data_reabertura : processo.data_conclusao)
                    );
                    const pausa = Number(processo.pausa_dias ?? 0);
                    const resultadoCorrigido = diasUteis - pausa;
                    return resultadoCorrigido >= 0 ? resultadoCorrigido : 0;
                })
            );

            const total = resultados.reduce((acc, val) => acc + val, 0);
            const media = resultados.length > 0 ? total / resultados.length : 0;

            let prazoDias = filtros.id_tipo_processo && (parseInt(filtros.id_tipo_processo) === 1 ? 2 : (parseInt(filtros.id_tipo_processo) === 2 ? 1 : 7));

            const percentual = prazoDias ? ((media / prazoDias) * 100) : 0;

            setRadialSeries([parseFloat(percentual.toFixed(2))]);
        };

        if (tempoMedioFinalizacao.length > 0) {
            calcularTempoMedioFinalizacao();
        }
    }, [tempoMedioFinalizacao, filtros]);

    useEffect(() => {
        (async () => {
            await getSearch();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const searchOperadora = async (e) => {
        e.preventDefault();
        return await business.getOperadora(e.target.value);
    }

    const searchEspecialidade = async (e) => {
        e.preventDefault();
        return await business.getEspecialidade(e.target.value);
    };

    const searchAreaAtuacao = async (e) => {
        e.preventDefault();
        return await business.getAreaAtuacao(e.target.value, 12, 1, filtros?.id_especialidade);
    };

    const coresCard = ['#24be34', '#adadad', '#0d6efd', '#ff7283'];
    const coresCard2 = ['black', 'black', '#24be34', '#24be34'];


    return (
        <Layout className="view-listagem">
            <div className="flex jc-sb ai-fc gap-30 w-100 mb-30">
                <div>
                    <p className="page-title">Relatórios</p>
                    <h2 className="title black-text">
                        Business Intelligence
                    </h2>
                </div>
                <div className='flex gap-20'>
                    <button className={`btn btn-${!filtro ? `outline-` : ''}primary filtros f700-16 jc-sb me-4`} onClick={() => setFiltro(!filtro)}>
                        <span className="desktop">Filtrar </span> <i className={`icon ${!filtro ? `icon-settings-sliders ` : `icon-exit `}i-20 ml-5 blue`} />
                    </button>
                </div>
            </div>
            {filtro && <div className="filtro-consulta form-container grid col-12 mb-30">
                <div className="w-100">
                    <div className="grid col-12 md-gap mb-20">
                        <InputForm
                            label="Tipo de processo"
                            required
                            type="select"
                            className="span-3"
                            name="id_tipo_processo"
                            options={typeProcess}
                            value={filtros?.id_tipo_processo}
                            model={(name, id) => {
                                const selectedProcess = typeProcess.find(process => process.id === Number(id));
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_tipo_processo: selectedProcess?.id || ''
                                }));
                            }}
                        />

                        {config.isSaastoUser() && <InputForm
                            label="Operadora"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchOperadora}
                            name="id_operadora"
                            model={(...params) => {
                                const idOperadora = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_operadora: idOperadora
                                }));
                            }}
                        />}

                        <InputForm
                            label="Especialidade"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchEspecialidade}
                            name="id_especialidade"
                            model={(...params) => {
                                const idEspecialidade = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_especialidade: idEspecialidade
                                }));
                            }}
                        />

                        <InputForm
                            label="Área de atuação"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchAreaAtuacao}
                            name="id_area_atuacao"
                            model={(...params) => {
                                const idAreaAtuacao = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_area_atuacao: idAreaAtuacao
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="w-100">
                    <div className="grid col-12">
                        <InputForm label="Data de início (Inicial)" type="date" id="inicio_processo_inicio" name="inicio_processo_inicio" model={setModel} value={filtros.inicio_processo_inicio} />
                        <span className="text-center interval">-</span>
                        <InputForm className="input-padding" label="Data de início (Final)" type="date" id="inicio_processo_fim" name="inicio_processo_fim" model={setModel} value={filtros.inicio_processo_fim} />
                        <InputForm
                            label="Data de conclusão (Inicial)"
                            type="date"
                            id="data_conclusao_inicio"
                            name="data_conclusao_inicio"
                            model={setModel}
                            value={filtros.data_conclusao_inicio}
                        />
                        <span className="text-center interval">-</span>
                        <InputForm
                            className="input-padding"
                            label="Data de conclusão (Final)"
                            type="date"
                            id="data_conclusao_fim"
                            name="data_conclusao_fim"
                            model={setModel}
                            value={filtros.data_conclusao_fim}
                        />
                        <button className="btn btn-primary f700-16 button-filtrar" onClick={() => {
                            getSearch(1, filtros?.texto || '', true);
                        }}>
                            Aplicar filtros
                        </button>
                        <span className="pointer float-right ml-10 mt-30" onClick={limparFiltros}>
                            <i className="icon icon-trash watermelon i-25" title="Limpar filtros" />
                        </span>
                    </div>
                </div>
            </div>}
            {
                loading ? (
                    <div className="loader loader-default is-active" />
                ) : (
                    <div className="iframe-wrapper mt-5">
                        <div className="text-center">
                            <div className="row align-items-start">
                                <div className="row w-100 grid col-12">
                                    <div className="col-6">
                                        <div className="text-center d-flex justify-content-center">
                                            <div className="row row-cols-4 g-1 align-items-start cards-container mb-10" style={{ gap: 0 }}>
                                                {dadosStatus.map((item, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card card-color f600-18" style={{ '--colorCard': coresCard[index % coresCard.length], gap: 20, minWidth: '150px' }}>
                                                            <div className="color" />
                                                            <div className="info">
                                                                <span className="text-black flex">{item.titulo}</span>
                                                                <span className="f600-32 mt-15">{item.valor}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {dadosFinanceiros.map((item, index) => (
                                            <div key={index} className="col-12 border-bi mb-2 p-5">
                                                {item.color && <p className="mb-0">Retorno de</p>}
                                                <h1 className="f600-24" style={{ color: coresCard2[index % coresCard2.length] }}>{item.valor}</h1>
                                                <p>{item.titulo}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-5" style={{ overflowX: "auto", width: "100%" }}>
                                            <p><strong>Distribuição por serviço</strong></p>

                                            <div className="flex justify-content-center">
                                                {donutSeries.map((series, index) => (
                                                    <Chart
                                                        options={{
                                                            chart: {
                                                                type: "radialBar",
                                                            },
                                                            plotOptions: {
                                                                radialBar: {
                                                                    dataLabels: {
                                                                        name: {
                                                                            show: false
                                                                        },
                                                                        value: {
                                                                            fontSize: "15px",
                                                                            show: true,
                                                                            offsetY: 5
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            tooltip: {
                                                                enabled: true,
                                                                y: {
                                                                    formatter: () => series.numeroProcessos,
                                                                    title: {
                                                                        formatter: () => `${series.label}:`
                                                                    }
                                                                }
                                                            },
                                                            colors: [donutColors[index]]
                                                        }}
                                                        series={[series.porcentagem]}
                                                        type="radialBar"
                                                        height="120"
                                                        width="120"
                                                    />
                                                ))}
                                            </div>
                                            <div className="ms-3">
                                                {donutSeries.map((series, index) => (
                                                    <div className="flex ai-fc gap-1">
                                                        <span
                                                            className="rounded"
                                                            style={{
                                                                width: "10px",
                                                                height: "10px",
                                                                backgroundColor: donutColors[index]
                                                            }}
                                                        ></span>
                                                        <p>{series.label}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="border-bi mb-2 p-5">
                                            <p className="text-start ms-2"><strong>Tempo médio finalização (Dias)</strong></p>
                                            <div>
                                                <Chart
                                                    options={radialOptions}
                                                    series={radialSeries}
                                                    type="radialBar"
                                                    height={400}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row w-100 grid col-12">
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start ms-2"><strong>Processos finalizados por especialidade</strong></p>
                                            <Chart
                                                options={chartOptions}
                                                series={chartSeries}
                                                type="bar"
                                                width="800"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start ms-2 mb-10"><strong>Saúde econômica por especialidade</strong></p>
                                            <div style={{ overflowY: "auto", maxHeight: "420px" }}>
                                                <table className="table table-striped fb-12">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Especialidade</th>
                                                            <th scope="col">Total</th>
                                                            <th scope="col">(%)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="mb-2">
                                                        {listagemSaude.map((p, i) => {
                                                            return (
                                                                <tr key={`desktop-${i}`}>
                                                                    <td className="fn-12 col-4">{p.especialidade}</td>
                                                                    <td className="fn-12 col-6">{tools.formatCurrency(p.total)}</td>
                                                                    <td className="fn-12 col-2">{p.percentual}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                        {(!listagemSaude || !listagemSaude?.length) && (
                                                            <tr>
                                                                <td colSpan={7}>Nenhum resultado encontrado.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="container text-center mb-4">
                                                <div className="row align-items-start">
                                                    <div className="col-4 text-start">
                                                        <p><strong>Total</strong></p>
                                                    </div>
                                                    <div className="col-4">
                                                        <p>
                                                            <strong>
                                                                {listagemSaude.reduce((acc, item) => acc + parseFloat(item.total || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </strong>
                                                        </p>
                                                    </div>
                                                    <div className="col-4 text-end">
                                                        <p><strong>{listagemSaude.reduce((acc, item) => acc + parseFloat(item.percentual), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>%</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-1"><p style={{ fontSize: "0.8em" }}>A saúde econômica é uma estimativa e pode ser muito maior, uma vez que não comtempla diárias, taxas e outros custos relacionados com a internação hospitalar.</p></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row w-100 grid col-12">
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start ms-2"><strong>Processos finalizados por área de atuação</strong></p>
                                            <Chart
                                                options={areaAtuacaoOptions}
                                                series={areaAtuacaoSeries}
                                                type="bar"
                                                width="800"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start ms-2 mb-10"><strong>Saúde econômica por área de atuação</strong></p>
                                            <div style={{ overflowY: "auto", maxHeight: "420px" }}>
                                                <table className="table table-striped fb-12">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Área de atuação</th>
                                                            <th scope="col">Total</th>
                                                            <th scope="col">(%)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="mb-2">
                                                        {listagemAtuacao.map((p, i) => {
                                                            return (
                                                                <tr key={`desktop-${i}`}>
                                                                    <td className="fn-12 col-4">{p.area_atuacao}</td>
                                                                    <td className="fn-12 col-6">{tools.formatCurrency(p.total)}</td>
                                                                    <td className="fn-12 col-2">{p.percentual}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                        {(!listagemAtuacao || !listagemAtuacao?.length) && (
                                                            <tr>
                                                                <td colSpan={7}>Nenhum resultado encontrado.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="container text-center mb-4">
                                                <div className="row align-items-start">
                                                    <div className="col-4 text-start">
                                                        <p><strong>Total</strong></p>
                                                    </div>
                                                    <div className="col-4">
                                                        <p>
                                                            <strong>
                                                                {listagemAtuacao.reduce((acc, item) => acc + parseFloat(item.total || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </strong>
                                                        </p>
                                                    </div>
                                                    <div className="col-4 text-end">
                                                        <p><strong>{listagemSaude.reduce((acc, item) => acc + parseFloat(item.percentual), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>%</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-1"><p style={{ fontSize: "0.8em" }}>A saúde econômica é uma estimativa e pode ser muito maior, uma vez que não comtempla diárias, taxas e outros custos relacionados com a internação hospitalar.</p></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row w-100 grid col-12">
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start  ms-2"><strong>Tipos de finalização</strong></p>
                                            <Chart
                                                options={tiposFinalizacao}
                                                series={tiposFinalizacaoSeries}
                                                type="bar"
                                                width="800"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="border-bi mb-2 p-10">
                                            <p className="text-start ms-2 mb-10"><strong>Ranking PA X Saúde econômica</strong></p>
                                            <div style={{ overflowY: "auto", maxHeight: "490px" }}>
                                                <table className="table table-striped fb-12">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Profissional assistente</th>
                                                            <th scope="col">Saúde econômica</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="mb-2">
                                                        {listagem.map((p, i) => {
                                                            return (
                                                                <tr key={`desktop-${i}`}>
                                                                    <td className="fn-12 col-5">{p.profissional}</td>
                                                                    <td className="fn-12 col-5">{tools.formatCurrency(p.economia)}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                        {(!listagem || !listagem?.length) && (
                                                            <tr>
                                                                <td colSpan={7}>Nenhum resultado encontrado.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="container text-center">
                                                <div className="row align-items-start">
                                                    <div className="col-6 text-start">
                                                        <p><strong>Total</strong></p>
                                                    </div>
                                                    <div className="col-6">
                                                        <p><strong>{listagem.reduce((acc, item) => acc + parseFloat(item.economia || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </Layout >
    );
}